import ChevronIcon from "@/assets/images/icons2/icon--chevron.svg?component";
import { Button2 } from "./Button";
import { cn } from "@/lib/helpers/cn";

type PaginationButtonProps = {
  variant: "previous" | "next";
};

export function PaginationButton({ variant }: PaginationButtonProps) {
  return (
    <Button2
      className="tw:size-8 tw:text-fill-secondary tw:disabled:cursor-not-allowed tw:disabled:text-text-quaternary"
      variant="blank"
      rawChildren
      slot={variant}
    >
      <ChevronIcon
        className={cn(
          "tw:block tw:size-6",
          variant === "previous" ? "tw:rotate-90" : "tw:-rotate-90",
        )}
      />
    </Button2>
  );
}
